import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import { AudioProvider } from './contexts/AudioContext';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');
createRoot(root).render(
  <AudioProvider>
    <App />
  </AudioProvider>
);
